<template>
  <v-card elevation="0" class="pa-6">
    <template #title>
      <div class="d-flex align-center justify-space-between">
        Classes
        <person-class-type-dialog
          v-if="env.mode === 'STAFF'"
          @override-added="reloadClasses"
        />
      </div>
    </template>
    <v-card-text>
      <class-calendar :manager="manager" />
    </v-card-text>
  </v-card>
  <v-card v-if="personId" elevation="0" class="pa-6" title="Enrollments">
    <v-card-text>
      <PersonClassEnrollments
        :key="personId"
        :person-id="personId"
        :refresh-key="classesVersion"
      />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import type { PersonStaff as Person } from "../../../../cbi-generator/generated/dto/PersonStaff";
import { useClassManager } from "@/composables/classes/useClassManager";
import PersonClassEnrollments from "../PersonClassEnrollments.vue";
import { useEnv } from "@/composables/useEnv";
import {
  memberOrderSessionKey,
  type MemberOrderSession,
} from "@/composables/shop/useMemberOrder";
const env = useEnv();
const person = inject<Ref<Person> | null>("person", null);
const memberOrder =
  env.mode === "MEMBER"
    ? inject<MemberOrderSession | null>(memberOrderSessionKey, null)
    : null;

const name = computed(() => person?.value.name ?? "");

const selectablePeople = ref([
  { title: name.value, value: person?.value?.personId ?? 0 },
]);

const props = {
  selectablePeople: selectablePeople,
  selectedPerson: person?.value?.personId ?? 0,
  memberOrder: memberOrder ?? undefined,
};

const manager = useClassManager(props);
const personId = computed(() => person?.value?.personId ?? 0);
// The calendar refetches classes after every enrollment change; reload the table with it.
const classesVersion = computed(() => manager.allClasses.value);

function reloadClasses() {
  manager.fetchClassEnrollmentAndEligibility(true);
}
watch(() => memberOrder?.order.value?.version, reloadClasses);
</script>
